export default {
  title: '供應鏈管理',
  supplierList: '供應商列表',
};
